import { memo } from 'react';

import { cn } from '../../../lib/cn';

interface NumberCellProps {
  value: number | null | undefined;
  locale?: string;
  className?: string;
}

const formatNumber = (value: number, locale: string): string => {
  return new Intl.NumberFormat(locale).format(value);
};

export const NumberCell = memo(function NumberCell({
  value,
  locale = 'pt-BR',
  className,
}: NumberCellProps) {
  if (value === null || value === undefined) {
    return <span className="text-slate-400">-</span>;
  }

  return (
    <span className={cn('tabular-nums', className)}>
      {formatNumber(value, locale)}
    </span>
  );
});
